import isMobileBrowser from 'is-mobile'
import isPrintMode from 'agency/digital_renderer/utils/isPrintMode'

function deviceCustomCSS(params){
  const { customCSS = {}, customMobileCSS = {}, customPrintCSS = {} } = params

  const isMobile = isMobileBrowser()
  const isPrint = isPrintMode()

  const baseCSS = { ...customCSS }
  delete baseCSS.key // remove the key as it is not a valid style property

  // Mobile
  if (isMobile){
    const mergedCSS = {
      ...baseCSS,
      ...customMobileCSS,
    }

    delete mergedCSS.key

    return mergedCSS
  }

  // Print
  if (isPrint){
    const mergedCSS = {
      ...baseCSS,
      ...customPrintCSS,
    }

    delete mergedCSS.key

    return mergedCSS
  }

  return baseCSS
}

export default deviceCustomCSS
